/**
 * Maps feature names to their corresponding route paths
 * Used for navigation, routing, and feature disable configuration
 */
export const featureRouteMap: Record<string, string[]> = {
  "Explore Customers": ["/customersearch", "/customer/:id?"],
  "Explore Products": ["/products", "/productview"],
  "Explore Reports": ["/explorereports", "/reportview/:reportId?"],
  "Explore Support": ["/exploresupport", "/supportreports/:category?", "/supportreportview/:reportId?"],
  "Explore Partners": ["/partnersearch", "/partners"],
  "Explore Feature Requests": ["/featurerequestsearch", "/featureflow/:id?"],
  "AI Hub": ["/aihub"],
  "My Favorites": ["/myfavorites"],
  "Data Research": ["/dataresearch", "/dataresearchview/:id?"],
  "Copilot Chat": ["/aichat"],
  "Product Scorecard": ["/productscorecard"]
};

/**
 * Feature flag: enables the streaming (Server-Sent Events) Copilot chat experience.
 * Defaults to OFF — the chat uses the original buffered request/response path until the
 * agent's streaming endpoint is available. Enable at build time with
 * REACT_APP_COPILOT_STREAMING="true".
 */
export const copilotStreamingEnabled: boolean =
  // eslint-disable-next-line no-undef
  process.env.REACT_APP_COPILOT_STREAMING === "true";
